import _styled5styled_components from 'styled-components';
            const _styled5 = typeof _styled5styled_components.default === 'undefined' ? _styled5styled_components : _styled5styled_components.default;;
import _styled4styled_components from 'styled-components';
            const _styled4 = typeof _styled4styled_components.default === 'undefined' ? _styled4styled_components : _styled4styled_components.default;;
import _styled3styled_components from 'styled-components';
            const _styled3 = typeof _styled3styled_components.default === 'undefined' ? _styled3styled_components : _styled3styled_components.default;;
import _styled2styled_components from 'styled-components';
            const _styled2 = typeof _styled2styled_components.default === 'undefined' ? _styled2styled_components : _styled2styled_components.default;;
import _styledstyled_components from 'styled-components';
            const _styled = typeof _styledstyled_components.default === 'undefined' ? _styledstyled_components : _styledstyled_components.default;;
import React, { useMemo } from 'react';
import { download } from '../utils/download';
import isTouchDevice from '../utils/isTouchDevice';
import { ArrowLeftIcon, ArrowRightIcon, DownloadIcon } from './Icons';
const StyledArrow = _styled.div.withConfig({
  componentId: "sc-3by9fo-0"
})(({
  visible
}) => [{
  "position": "absolute",
  "top": "0px",
  "bottom": "0px",
  "zIndex": "50",
  "margin": "auto",
  "display": "flex",
  "height": "fit-content",
  "width": "fit-content",
  "cursor": "pointer",
  "userSelect": "none",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "0.375rem",
  "backgroundColor": "rgb(31 41 55 / 0.9)",
  "padding": "0.5rem",
  "fontSize": "16px",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "opacity": "1",
  "transitionProperty": "opacity",
  "transitionTimingFunction": "linear",
  "transitionDuration": "150ms",
  "transitionDelay": "200ms",
  ":hover": {
    "opacity": "1"
  },
  "@media (min-width: 640px)": {
    "backgroundColor": "rgb(31 41 55 / 0.6)",
    "padding": "0.625rem",
    "fontSize": "20px",
    "opacity": "0.9"
  },
  "@media (min-width: 768px)": {
    "backgroundColor": "rgb(31 41 55 / 0.3)",
    "opacity": "0.75"
  }
}, !visible && {
  "opacity": "0"
}]);
const StyledArrowLeft = _styled(StyledArrow).withConfig({
  componentId: "sc-3by9fo-1"
})({
  "left": "0.5rem",
  "@media (min-width: 640px)": {
    "left": "0.75rem"
  },
  "@media (min-width: 768px)": {
    "left": "1rem"
  },
  "@media (min-width: 1024px)": {
    "left": "1.25rem"
  }
});
const StyledArrowRight = _styled(StyledArrow).withConfig({
  componentId: "sc-3by9fo-2"
})({
  "right": "0.5rem",
  "@media (min-width: 640px)": {
    "right": "0.75rem"
  },
  "@media (min-width: 768px)": {
    "right": "1rem"
  },
  "@media (min-width: 1024px)": {
    "right": "1.25rem"
  }
});
export const SlideArrowLeft = ({
  index,
  images,
  loop,
  onIndexChange,
  overlayVisible,
  className,
  children
}) => {
  const count = images.length;
  const isFirst = index === 0;
  const prev = () => {
    onIndexChange(isFirst ? count - 1 : index - 1);
  };
  const arrowLeftVisible = useMemo(() => {
    if (isTouchDevice || !overlayVisible) return false;
    if (loop) return true;
    return !isFirst;
  }, [index, count, loop, isFirst]);
  return <StyledArrowLeft visible={arrowLeftVisible} onClick={prev} className={className}>
      {children ?? <ArrowLeftIcon />}
    </StyledArrowLeft>;
};
export const SlideArrowRight = ({
  index,
  images,
  loop,
  onIndexChange,
  overlayVisible,
  className,
  children
}) => {
  const count = images.length;
  const isLast = index === count - 1;
  const next = () => {
    onIndexChange(isLast ? 0 : index + 1);
  };
  const arrowRightVisible = useMemo(() => {
    if (isTouchDevice || !overlayVisible) return false;
    if (loop) return true;
    return !isLast;
  }, [isLast, isTouchDevice, loop, overlayVisible]);
  return <StyledArrowRight visible={arrowRightVisible} onClick={next} className={className}>
      {children ?? <ArrowRightIcon />}
    </StyledArrowRight>;
};
export const SlideCountText = ({
  index,
  images,
  className,
  children
}) => {
  const count = images.length;
  return <_StyledDiv className={className}>
      <_StyledLabel>
        {children ?? `${index + 1}/${count}`}
      </_StyledLabel>
    </_StyledDiv>;
};
export const SlideDownload = ({
  loading,
  images,
  index,
  className,
  children
}) => {
  const handleDownload = () => {
    const {
      src
    } = images[index];
    if (!src) return;
    download(src);
  };
  return <_StyledDiv2 className={className}>
      <_StyledButton disabled={loading} onClick={handleDownload}>
        {children ?? <DownloadIcon />}
      </_StyledButton>
    </_StyledDiv2>;
};
export const SlideToolbarItemDefaultComponent = {
  arrowLeft: SlideArrowLeft,
  arrowRight: SlideArrowRight,
  countText: SlideCountText,
  download: SlideDownload
};
export const SlideToolbar = ({
  children,
  items = ['arrowLeft', 'arrowRight', 'countText', 'download'],
  ...props
}) => {
  if (children) return children;
  return <>
      {items.map(key => {
      const Component = SlideToolbarItemDefaultComponent[key];
      if (Component) return <Component {...props} />;
      return null;
    })}
    </>;
};
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-3by9fo-3"
})({
  "position": "absolute",
  "bottom": "1.25rem",
  "left": "0.5rem",
  "zIndex": "30",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "@media (min-width: 640px)": {
    "left": "0.75rem"
  },
  "@media (min-width: 768px)": {
    "left": "1rem"
  },
  "@media (min-width: 1024px)": {
    "left": "1.25rem"
  }
});
var _StyledLabel = _styled("label").withConfig({
  componentId: "sc-3by9fo-4"
})({
  "marginTop": "0px",
  "marginBottom": "0px",
  "marginLeft": "0px",
  "marginRight": "0px",
  "cursor": "default",
  "borderRadius": "0.375rem",
  "backgroundColor": "rgb(31 41 55 / 0.9)",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "paddingTop": "0.125rem",
  "paddingBottom": "0.125rem",
  "fontSize": "16px",
  "opacity": "1",
  "transitionProperty": "opacity",
  "transitionTimingFunction": "linear",
  "transitionDuration": "150ms",
  "transitionDelay": "200ms",
  ":hover": {
    "opacity": "1"
  },
  ":disabled": {
    "cursor": "not-allowed",
    "--tw-text-opacity": "1",
    "color": "rgb(75 85 99 / var(--tw-text-opacity))"
  },
  "@media (min-width: 640px)": {
    "backgroundColor": "rgb(31 41 55 / 0.6)",
    "paddingLeft": "0.625rem",
    "paddingRight": "0.625rem",
    "paddingTop": "0.25rem",
    "paddingBottom": "0.25rem",
    "fontSize": "20px",
    "opacity": "0.9"
  },
  "@media (min-width: 768px)": {
    "backgroundColor": "rgb(31 41 55 / 0.3)",
    "opacity": "0.75"
  }
});
var _StyledDiv2 = _styled("div").withConfig({
  componentId: "sc-3by9fo-5"
})({
  "position": "absolute",
  "bottom": "1.25rem",
  "right": "0.5rem",
  "zIndex": "30",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "@media (min-width: 640px)": {
    "right": "0.75rem"
  },
  "@media (min-width: 768px)": {
    "right": "1rem"
  },
  "@media (min-width: 1024px)": {
    "right": "1.25rem"
  }
});
var _StyledButton = _styled("button").withConfig({
  componentId: "sc-3by9fo-6"
})({
  "margin": "0px",
  "cursor": "pointer",
  "borderRadius": "0.375rem",
  "backgroundColor": "rgb(31 41 55 / 0.9)",
  "padding": "0.5rem",
  "fontSize": "16px",
  "opacity": "1",
  "transitionProperty": "opacity",
  "transitionTimingFunction": "linear",
  "transitionDuration": "150ms",
  "transitionDelay": "200ms",
  ":hover": {
    "opacity": "1"
  },
  ":disabled": {
    "cursor": "not-allowed",
    "--tw-text-opacity": "1",
    "color": "rgb(75 85 99 / var(--tw-text-opacity))"
  },
  ":disabled:hover": {
    "backgroundColor": "transparent"
  },
  "@media (min-width: 640px)": {
    "backgroundColor": "rgb(31 41 55 / 0.6)",
    "padding": "0.625rem",
    "fontSize": "20px",
    "opacity": "0.9"
  },
  "@media (min-width: 768px)": {
    "backgroundColor": "rgb(31 41 55 / 0.3)",
    "opacity": "0.75"
  }
});